import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page67() {
  useEffect(() => {
    document.title = "Маяк — Страница 66"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page65" />
        <ForwardLink href="/page67" />
      </div>

      <p style={{ textAlign: "right" }}>66.</p>
      <p>Он делает глоток из бутылки.</p>
      <p>ОГОНЬ ПЫЛАЕТ.</p>
      <p>ЕЩЕ ОДИН БОЛЬШОЙ, ДОЛГИЙ ГЛОТОК.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. БЕРЕГ – ДЕНЬ</p>
      <p>ШТОРМ БЕСПОЩАДЕН КАК ВСЕГДА.</p>
      <p>МОЛОДОЙ тащит ВЕРЕВКУ С ЛОВУШКОЙ ДЛЯ ОМАРОВ...</p>
      <p>КАРТИНКА: ГРУДЬ РУСАЛКИ.</p>
      <p>КАРТИНКА: ЕЕ РОТ.</p>
      <p>МОЛОДОЙ тащит веревку...</p>
      <p>
        КАРТИНКА: МАЯК, под углом 45 градусов, ВЫГЛЯДИТ КАК<br/>
        ПЕНИС.
      </p>
      <p>МОЛОДОЙ тащит веревку...</p>
      <p>КАРТИНКА: СЛИЗИСТАЯ ВАГИНА РУСАЛКИ.</p>
      <p>КАРТИНКА: РУКИ МОЛОДОГО КРЕПКО ДЕРЖАТ КРЮК.</p>
      <p>КАРТИНКА: ВЛАЖНЫЕ ЩУПАЛЬЦА ИЗВИВАЮТСЯ</p>
      <p>
        КАРТИНКА: ЛИЦО РУСАЛКИ, ПЕРЕВЕРНУТОЕ. КРИЧИТ, СТОНЕТ.<br/>
        ГЛАЗА ЗАКАТИЛИСЬ В ЗАТЫЛОК.
      </p>
      <p>МОЛОДОЙ тащит...</p>
      <p>
        КАРТИНКА: БЛИЗКО: ЗАТЫЛОК МУЖЧИНЫ. ШЕРСТЯНОЙ ВОРОТНИК<br/>
        МАКИНО.
      </p>
      <p style={{ textAlign: "right" }}>БЫСТРЫЙ ПЕРЕХОД К:</p>
      <br/>
      <p>ВНУТРИ. САРАЙ – ДЕНЬ</p>
      <p>МОЛОДОЙ МАСТУРБИРУЕТ В ТЕМНОТЕ. ВЗБЕШЕННЫЙ. ЗЛОЙ. РАСТЕРЯННЫЙ.</p>
      <p>
        Рубашка снята. Клеенчатая шляпа на голове. Дрожит. Дождь мочится на него<br/>
        через дыры в крыше.
      </p>
      <p>
        Он держит ВЫРЕЗАННУЮ РУСАЛКУ. Смотрит на нее. Это<br/>
        не работает.
      </p>
      <p>
        Он запрокидывает голову, думая о ком-то, о чем-то. Он<br/>
        делает это с яростью... похотью...
      </p>
      <p style={{ textAlign: "right" }}>66.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page65" />
        <ForwardLink href="/page67" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710632658/the-lighthouse-script/eakeinwh1pfmnmvlce6y.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page67;
